export default __webpack_public_path__ + "static/media/hero-big.e24c3331.jpg";